<template>
  <div>
    <b-container fluid>
      <ConfiguratorStepTitle :step="configuratorStepNumber" title="COMPONENTES" />

      <b-row align-h="center" class="mt-5">
        <b-col lg="9" cols="10">
          <p class="configurator-label">
            <BlankIcon :field="form.components.length > 0 ? 'active' : null" />
            Seleccione los componentes deseados para el nivelador de andén
          </p>
          <div class="d-flex flex-wrap align-items-center justify-content-around mt-5">
            <CheckboxCard
              :imageSrc="''"
              :emptyImage="true"
              :imageText="'Sin \ncomponentes'"
              title="No aplica"
              description="No requiere componentes"
              :checked="form.components.includes('no requiere')"
              @change="handleComponentChange('no requiere', $event)"
            />
            <CheckboxCard
              :imageSrc="retenedorRuedasImg"
              title="Retenedor de Rueda"
              :checked="form.components.includes('Retenedor de Rueda')"
              @change="handleComponentChange('Retenedor de Rueda', $event)"
            />
            <CheckboxCard
              :imageSrc="lamparaImg"
              title="Lámpara"
              :checked="form.components.includes('lampara')"
              @change="handleComponentChange('lampara', $event)"
            />
            <CheckboxCard
              :imageSrc="semaforoImg"
              title="Automático"
              description="Kit de Semáforo"
              :checked="form.components.includes('semaforo automatico')"
              @change="handleComponentChange('semaforo automatico', $event)"
            />
            <CheckboxCard
              :imageSrc="semaforoImg"
              title="Manual"
              description="Kit de Semáforo"
              :checked="form.components.includes('semaforo manual')"
              @change="handleComponentChange('semaforo manual', $event)"
            />
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapState, mapGetters} from 'vuex'
import MissingImg from '../../../../../../public/images/original/missing.png'

import ConfiguratorStepTitle from '../ConfiguratorStepTitle'
import ProductCard from './ProductCard'
import CheckboxCard from '../CheckboxCard'
import BlankIcon from '../BlankIcon'
import SemaforoImage from 'images/andenes/semaforo_anden.webp'
import LamparaImage from 'images/andenes/lampara_anden.webp'
import retenedorRuedasImage from 'images/andenes/retenedor_ruedas.webp'

export default {
  name: 'Components',
  components: { ConfiguratorStepTitle, BlankIcon, ProductCard, CheckboxCard },
  props: {
    updateConfigurable: Function
  },
  data () {
    return {
      semaforoOptions: [
        { text: 'Kit de Semáforo Automático', value: 'semaforo automatico' },
        { text: 'Kit de Semáforo Manual', value: 'semaforo manual' }
      ],
      form: {
        components: []
      },
      missingImg: MissingImg,
      semaforoImg: SemaforoImage,
      lamparaImg: LamparaImage,
      retenedorRuedasImg: retenedorRuedasImage
    }
  },
  mounted () {
    this.form.components = this.anden.components
  },
  computed: {
    ...mapState({ anden: state => state.configurator.configurable }),
    ...mapGetters(['configuratorStepNumber'])
  },
  methods: {
    handleComponentChange(value, isChecked) {
      if (!value) return

      const { components } = this.form

      if (isChecked) {
        if (value === 'no requiere') {
          this.form.components = ['no requiere']
          return
        }

        this.form.components = components.filter(c => c !== 'no requiere')

        if (components.includes(value)) return

        if (value === 'semaforo automatico' && this.form.components.includes('semaforo manual')) {
          this.form.components = this.form.components.filter(c => c !== 'semaforo manual')
        } else if (value === 'semaforo manual' && this.form.components.includes('semaforo automatico')) {
          this.form.components = this.form.components.filter(c => c !== 'semaforo automatico')
        }

        this.form.components.push(value)
        return
      }

      this.form.components = components.filter(c => c !== value)
    },
    async update () {
      const result = await this.updateConfigurable(this.form)
      return result
    }
  }
}
</script>
